/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Text } from 'grommet';
import { Field } from 'react-final-form';

export const FormError: React.FC<{ name: string }> = ({ name }) => (
  <Field
    name={name}
    render={({ meta: { touched, error } }) => {
      if (!touched || !error) return null;
      // error can be an array of errors if the field that the errors are for is
      // an array, i.e. team members. It can also be an object since this
      // catches all errors which are normally mapped to fields, for example
      // like: { name: 'name required' }. So by only allowing strings, we only
      // render errors returned from validation functions that are mapped to the
      // name given to this component as a prop instead of other errors rendered
      // by other fields.
      const errors = Array.isArray(error) ? error.filter(e => !!e && typeof e === 'string') : [error];

      return errors.map((err: string) => (
        <Text color="accentRed" key={err} size="xsmall">
          {err}
        </Text>
      ));
    }}
    subscription={{ touched: true, error: true }}
  />
);
